// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__L88D-"};